import React from "react";

import { ReactComponent as Icon } from "./identity-verification-icon.svg";

type Props = {
  color?: string;
  style?: React.CSSProperties;
};

export const IdentityVerifyIcon: React.FC<Props> = () => {
  return <Icon color="grey" height={100} />;
};
